import { CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FeatureBundle } from 'app/shared/service/subscriptions.model';
import { SupportService } from 'app/shared/support/support.service';
import { UiModule } from 'app/shared/ui';
import { OverlayRef } from 'app/shared/ui/overlays';


type Period = 'monthly' | 'yearly';


@Component({
    selector: 'feature-bundle-detail-modal',
    imports: [
        RouterLink,
        CurrencyPipe,
        UiModule,
    ],
    styles: [
        `
        .image {
            max-width: 140px;
            display: inline-block;
        }
        .features {
            padding: 0;
            margin: 0;
            list-style: none;
            text-align: left;
        }
        .features li {
            background: url(/assets/images/skills-centre/check.png) no-repeat left 7px;
            padding-left: 20px;
            background-size: 10px 8px;
            padding-bottom: 10px;
        }
        .note {
            font-size: x-small;
        }
        .price {
            font-size: large;
        }
        .two-months-free {
            width: 77px;
            position: absolute;
            margin-left: -30px;
            margin-top: -21px;
        }
        `,
    ],
    template: `
        <ui-modal size="lg">
            <modal-header>
                Feature Bundle
            </modal-header>
            <modal-body>
                <div class="row pt-4">
                    <div class="col-5 text-center px-5">
                        <div class="image">
                            <img width="100%" src="/assets/images/skills-centre/{{ featureBundle.detailIcon }}" alt="">
                        </div>
                        <ul class="features mt-3">
                            @for (feature of featureBundle.features; track feature) {
                                <li>
                                    <a target="_blank" [href]="feature.url">{{ feature.label }}</a>
                                </li>
                            }
                        </ul>
                    </div>

                    <div class="col-7">
                        <h1>{{ featureBundle.name }}</h1>

                        @if (featureBundle.withinDeal) {
                            <div class="mb-3">
                                <strong>
                                    <span class="price">{{ featureBundle.price.monthly | currency:'CAD':'symbol-narrow':'1.0-3' }}</span>/monthly
                                    or
                                    <span class="price">{{ featureBundle.price.yearly | currency:'CAD':'symbol-narrow':'1.0-3' }}</span>/annually
                                    @if (boardName) {
                                        <div>Included with membership to {{ boardName }}</div>
                                    }
                                </strong>
                            </div>
                        }
                        @else {
                            <div class="mb-3">
                                <strong>
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input
                                                class="form-check-input radio-big"
                                                type="radio"
                                                name="price"
                                                (change)="chosenBillingPeriod = 'monthly'"
                                                [checked]="chosenBillingPeriod == 'monthly'">
                                            <span class="price">{{ featureBundle.price.monthly | currency:'CAD':'symbol-narrow':'1.0-3' }}</span>/monthly
                                        </label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <label class="form-check-label">
                                            <input
                                                class="form-check-input radio-big"
                                                type="radio"
                                                name="price"
                                                (change)="chosenBillingPeriod = 'yearly'"
                                                [checked]="chosenBillingPeriod == 'yearly'">
                                            <span class="price">{{ featureBundle.price.yearly | currency:'CAD':'symbol-narrow':'1.0-3' }}</span>/annually
                                        </label>
                                    </div>
                                    <img alt="2 months free" class="two-months-free" src="/assets/images/skills-centre/two-months-free.png">
                                </strong>

                                <div class="pt-2">
                                    @if (!canSubscribe()) {
                                        <button
                                            type="button"
                                            class="btn btn-primary"
                                            (click)="openSupport()">
                                            Contact us
                                        </button>
                                    }
                                    @else {
                                        <button
                                            type="button"
                                            [class.btn-primary]="!active"
                                            [class.btn-secondary]="active"
                                            class="btn"
                                            (click)="subscribe()"
                                            [disabled]="active">
                                            {{ active ? 'Subscribed' : 'Subscribe now' }}
                                        </button>
                                    }
                                </div>
                            </div>
                        }

                        <div [innerHTML]="featureBundle.description"></div>
                    </div>
                </div>
            </modal-body>
            <modal-footer class="border-top-0">
                <button class="btn btn-link mr-auto" (click)="close()">Close</button>
                <button class="btn btn-secondary" (click)="openBillingPage()" routerLink="/dashboard/my-autoprop/billing">
                    Manage Subscriptions
                </button>
            </modal-footer>
        </ui-modal>
    `,
})
export class FeatureBundleDetailModalComponent {

    @Input() featureBundle: FeatureBundle;

    @Input() chosenBillingPeriod: Period;

    @Input() userBillingPeriod: null | Period;

    @Input() active: boolean;

    @Input() boardName: string | null;

    constructor(private overlayRef: OverlayRef, private supportService: SupportService) {}

    openBillingPage() {
        this.overlayRef.close({ action: 'openBillingPage' });
    }

    close() {
        this.overlayRef.close({ action: 'close' });
    }

    canSubscribe() {
        // user has no package active
        if (!this.userBillingPeriod) {
            return true;
        }

        // selected period is the same as of user's already purchased bundle
        return this.userBillingPeriod === this.chosenBillingPeriod;
    }

    subscribe() {
        const result = {
            action: 'subscribe',
            featureBundle: this.featureBundle,
            chosenBillingPeriod: this.chosenBillingPeriod,
        };
        this.overlayRef.close(result);
    }

    openSupport() {
        this.supportService.openSupport();
    }
}
